<script setup lang="ts">
// Components of Module
import { Marker as GoogleMarker } from 'vue3-google-map'

// Assets
import closeMarkerImage from '@/assets/images/app-icons/closed-marker.svg'
import openMarkerImage from '@/assets/images/app-icons/opened-marker.svg'

// Types
import { PointProperties } from '@/api/modules/delivery/types'
import {
  TypesEntity,
  IGoogleCoords,
  GoogleClickEvent,
} from '@/types/mapServices'

defineProps({
  points: {
    type: Array as PropType<PointProperties[]>,
    required: false,
    default: () => [],
  },
  clickedRestaurant: {
    type: Object as PropType<PointProperties | null>,
    required: true,
  },
})

const emits = defineEmits(['clickedToMapOfElement'])

// Определяем опции для точки на карте
const generateOptionOfPoint = (marker: PointProperties) => {
  return {
    position: {
      lat: marker.coordinates[0],
      lng: marker.coordinates[1],
    },
    icon: marker.is_open ? openMarkerImage : closeMarkerImage,
  }
}

const clickedPoint = (marker: PointProperties, event: GoogleClickEvent) => {
  const markerCoords: IGoogleCoords = {
    lat: event.latLng.lat(),
    lng: event.latLng.lng(),
  }

  emits('clickedToMapOfElement', {
    type: TypesEntity.MARKER,
    coords: markerCoords,
    point: marker,
  })
}
</script>

<template>
  <google-marker
    v-for="(marker, index) in points"
    :key="`point-${index}-${marker.id}`"
    :options="generateOptionOfPoint(marker)"
    @click="clickedPoint(marker, $event)"
  />
</template>
